<template lang="pug">
  #app
    router-view
</template>

<script>
export default {
  name: 'App'
};
</script>

<style lang="scss">
  @import '~normalize.css/normalize.css';// normalize.css 样式格式化
  @import './styles/index.scss'; // 全局自定义的css样式
  #app{
    background: #1a1c2a;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue?d86163fe